/**
 * footer-v3.js
 * Minimal, accessible JS for:
 *  1. Mobile accordion toggle (Exclusive accordion logic)
 *  2. Back-to-top button visibility + scroll
 *  3. Viewport entrance animation trigger
 */

(function () {
  'use strict';

  /* ── 1. ACCORDION ── */
  function initAccordions() {
    const toggles = document.querySelectorAll('[data-accordion-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (btn) {
      // Skip if explicitly disabled (desktop only blocks)
      if (btn.disabled) return;

      const col = btn.closest('[data-accordion-col]');
      const bodyId = btn.getAttribute('aria-controls');
      const body = bodyId ? document.getElementById(bodyId) : null;
      if (!col || !body) return;

      btn.addEventListener('click', function () {
        // Only run on mobile — guard with matchMedia
        if (!isMobile()) return;

        const isOpen = col.classList.contains('is-open');

        if (isOpen) {
          close(col, btn, body);
        } else {
          // Requirement: "only one menu should be open at a time"
          // Close all other open columns in the footer
          const allCols = document.querySelectorAll('[data-accordion-col].is-open');
          allCols.forEach(function (openCol) {
            if (openCol === col) return;
            const openBtn = openCol.querySelector('[data-accordion-toggle]');
            const openBodyId = openBtn?.getAttribute('aria-controls');
            const openBody = openBodyId ? document.getElementById(openBodyId) : null;
            if (openBtn && openBody) {
              close(openCol, openBtn, openBody);
            }
          });
          
          open(col, btn, body);
        }
      });
    });
  }

  function open(col, btn, body) {
    col.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    body.removeAttribute('hidden');
  }

  function close(col, btn, body) {
    col.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    // Wait for CSS transition before hiding
    const speed = getSpeed();
    setTimeout(function () {
      if (!col.classList.contains('is-open')) {
        body.setAttribute('hidden', '');
      }
    }, speed);
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getSpeed() {
    const footer = document.querySelector('.footer-v3');
    if (!footer) return 300;
    const val = getComputedStyle(footer).getPropertyValue('--footer-accordion-speed');
    return parseInt(val, 10) || 300;
  }

  // Re-evaluate on resize: ensure desktop always shows content
  function onResize() {
    if (!isMobile()) {
      document.querySelectorAll('[data-accordion-col]').forEach(function (col) {
        const bodyId = col.querySelector('[data-accordion-toggle]')?.getAttribute('aria-controls');
        const body = bodyId ? document.getElementById(bodyId) : null;
        if (body) body.removeAttribute('hidden');
      });
    }
  }

  /* ── 2. BACK TO TOP ── */
  function initBackToTop() {
    const btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;

    function updateVisibility() {
      if (window.scrollY > 400) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
  }

  /* ── 3. VIEWPORT ANIMATION ── */
  function initViewportAnimation() {
    const footer = document.querySelector('.footer-v3--animate');
    if (!footer) return;

    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.05 }
      );
      obs.observe(footer);
    } else {
      // Fallback: just show immediately
      footer.classList.add('is-visible');
    }
  }

  /* ── INIT ── */
  function init() {
    initAccordions();
    initBackToTop();
    initViewportAnimation();

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onResize, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
